import { useTranslation } from 'react-i18next';
import { Button, LoadingIcon, Tooltip } from '@sib/ui';
import { ArrowIcon } from '@spendbrain/icons';
import { useFileManagerFileUploadStore } from '@spendbrain/stores/fileUploadStore';

interface UploadFileButtonProps {
  onClick: () => void;
}

export const UploadFileButton = ({ onClick }: UploadFileButtonProps) => {
  const { t } = useTranslation();
  const isUploading = useFileManagerFileUploadStore().getAreFilesUploading();

  return (
    <Tooltip content={t('dragAndDrop')} TooltipTriggerProps={{ asChild: true }}>
      <Button onClick={onClick} className="p-0.5 sm:p-[6px]" variant="outline">
        <div className="border-[rgba(1, 24, 63, 0.5)] flex items-center gap-2 rounded-sm border border-dashed px-1.5 py-0.5 sm:px-3">
          {isUploading ? (
            <LoadingIcon className="text-primary h-5" />
          ) : (
            <ArrowIcon className="text-primary h-5" />
          )}
          <p className="text-primary hidden leading-4 md:block">
            {t('fileManager.uploadFiles')}
          </p>
        </div>
      </Button>
    </Tooltip>
  );
};
